import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const PUBLIC_BASE_URL = process.env.REACT_APP_PUBLIC_BASE_URL;

export const getAllCourses = createAsyncThunk(
    'course/getAllCourses',
    async ({ skip, limit, search, status, role_name }, { rejectWithValue }) => {
        try {
            const params = {};
            if (skip !== undefined) params.skip = skip;
            if (limit !== undefined) params.limit = limit;
            if (search) params.search = search;
            if (status) params.status = status;
            if (role_name) params.role_name = role_name;

            const config = {
                headers: {
                    "Content-Type": "application/json",
                },
                withCredentials: true,
                params,
            };

            const response = await axios.get(`${PUBLIC_BASE_URL}/courses`, config);
            return (response.data);

        } catch (err) {
            if (err.message === "Network Error") {
                return rejectWithValue({
                    response: {
                        data: {
                            message: "Network Error",
                            status: err.code,
                            statusText: err.code,
                        },
                    },
                });
            } else {
                return rejectWithValue(
                    err.response?.data?.message || 'An error occurred'
                );
            }
        }
    }
);

export const addNewCourse = createAsyncThunk(
    'course/addNewCourse',
    async (courseData, { rejectWithValue }) => {
        try {
            const config = {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
                withCredentials: true,
            };

            const formData = new FormData();

            if (courseData.title) formData.append("title", courseData.title);
            if (courseData.slug) formData.append("slug", courseData.slug);
            if (courseData.description) formData.append("description", courseData.description);
            if (courseData.price) formData.append("price", courseData.price);
            if (courseData.userId) formData.append("userId", courseData.userId);
            if (courseData.courseCategoryId) formData.append("courseCategoryId", courseData.courseCategoryId);
            if (courseData.read_more) formData.append("read_more", courseData.read_more);
            if (courseData.thumbnailImage) formData.append("thumbnailImage", courseData.thumbnailImage);

            const response = await axios.post(`${PUBLIC_BASE_URL}/courses/create-course`, formData, config);
            return response.data;
        } catch (err) {
            if (err.message === "Network Error") {
                return rejectWithValue({
                    message: "Network Error",
                    status: err.code,
                    success: false
                });
            } else {
                return rejectWithValue(err.response?.data || 'Unknown error occurred.');
            }
        }
    }
);

export const editCourse = createAsyncThunk(
    'course/editCourse',
    async (updatedData, { rejectWithValue }) => {
        try {

            const config = {
                headers: {
                    "Content-Type": "application/json",
                },
                withCredentials: true,
            };

            const body = JSON.stringify(updatedData);
            const response = await axios.put(`${PUBLIC_BASE_URL}/courses/update-course-info`, body, config);
            return response.data;
        } catch (err) {
            if (err.message === "Network Error") {
                return rejectWithValue({
                    message: "Network Error",
                    status: err.code,
                    success: false
                });
            } else {
                return rejectWithValue(err.response?.data || 'Unknown error occurred.');
            }
        }
    }
);

export const getCourseById = createAsyncThunk(
    'course/getCourseById',
    async ({ id }, { rejectWithValue }) => {
        try {

            const config = {
                headers: {
                    "Content-Type": "application/json",
                },
                withCredentials: true,
            };

            const response = await axios.get(`${PUBLIC_BASE_URL}/courses/${id}`, config);
            return (response.data);

        } catch (err) {
            if (err.message === "Network Error") {
                return rejectWithValue({
                    response: {
                        data: {
                            message: "Network Error",
                            status: err.code,
                            statusText: err.code,
                        },
                    },
                });
            } else {
                return rejectWithValue(
                    err.response?.data?.message || 'An error occurred'
                );
            }
        }
    }
);

export const addNewVideo = createAsyncThunk(
    'course/addNewVideo',
    async (videoData, { rejectWithValue }) => {
        try {
            const config = {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
                withCredentials: true,
            };

            const formData = new FormData();
            if (videoData[1]) formData.append("courseId", videoData[1]);
            if (videoData[0].title) formData.append("title", videoData[0].title);
            if (videoData[0].description) formData.append("description", videoData[0].description);
            if (videoData[0].read_more) formData.append("read_more", videoData[0].read_more);
            if (videoData[0].thumbnail) formData.append("thumbnail", videoData[0].thumbnail);
            if (videoData[0].doc) formData.append("doc", videoData[0].doc);
            if (videoData[0].doc_title) formData.append("doc_title", videoData[0].doc_title);
            if (videoData[0].video_url) formData.append("video_url", videoData[0].video_url);
            if (videoData[0].slug) formData.append("slug", videoData[0].slug);
            if (videoData[0].order) formData.append("order", videoData[0].order);

            const response = await axios.post(`${PUBLIC_BASE_URL}/videos/create-video`, formData, config);
            return response.data;
        } catch (err) {
            if (err.message === "Network Error") {
                return rejectWithValue({
                    message: "Network Error",
                    status: err.code,
                    success: false
                });
            } else {
                return rejectWithValue(err.response?.data || 'Unknown error occurred.');
            }
        }
    }
);

export const getActiveCourses = createAsyncThunk(
    'course/getActiveCourses',
    async ({ skip, limit,  }, { rejectWithValue }) => {
        try {
            const params = {};
            if (skip !== undefined) params.skip = skip;
            if (limit !== undefined) params.limit = limit;

            const config = {
                headers: {
                    "Content-Type": "application/json",
                },
                withCredentials: true,
                params,
            };

            const response = await axios.get(`${PUBLIC_BASE_URL}/courses/active-courses`, config);
            return (response.data);

        } catch (err) {
            if (err.message === "Network Error") {
                return rejectWithValue({
                    response: {
                        data: {
                            message: "Network Error",
                            status: err.code,
                            statusText: err.code,
                        },
                    },
                });
            } else {
                return rejectWithValue(
                    err.response?.data?.message || 'An error occurred'
                );
            }
        }
    }
);
